import { httpsCallable } from 'actions/firebase/functions'

const payBooking = async (bookingId, query, gateway, method) =>
  httpsCallable('payBooking', { bookingId, query, gateway, method })

export default payBooking
